// extracted by mini-css-extract-plugin
export default {"container":"InviteTalentFromSearchDialog_container__VAvvi"};